import React from 'react';
import { IconProps } from '../../types/ui';

const IconMove = ({ color = '#343330' }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.1308 1.95454C10.3651 1.72023 10.745 1.72023 10.9793 1.95454L13.0234 3.99863C13.2577 4.23294 13.2577 4.61284 13.0234 4.84716L10.9793 6.89124C10.745 7.12555 10.3651 7.12555 10.1308 6.89124C9.8965 6.65692 9.8965 6.27702 10.1308 6.04271L11.7506 4.42289L10.1308 2.80307C9.8965 2.56876 9.8965 2.18886 10.1308 1.95454Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.44486 5.02275C5.06187 5.02275 4.69456 5.1749 4.42374 5.44572C4.15293 5.71653 4.00078 6.08384 4.00078 6.46684V7.48888C4.00078 7.82025 3.73215 8.08888 3.40078 8.08888C3.06941 8.08888 2.80078 7.82025 2.80078 7.48888V6.46684C2.80078 5.76558 3.07935 5.09305 3.57522 4.59719C4.07108 4.10133 4.74361 3.82275 5.44486 3.82275L12.5992 3.82275C12.9305 3.82275 13.1992 4.09138 13.1992 4.42275C13.1992 4.75412 12.9305 5.02275 12.5992 5.02275L5.44486 5.02275Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.86913 9.10884C6.10344 9.34316 6.10344 9.72305 5.86913 9.95737L4.24931 11.5772L5.86913 13.197C6.10344 13.4313 6.10344 13.8112 5.86913 14.0455C5.63481 14.2798 5.25491 14.2798 5.0206 14.0455L2.97652 12.0015C2.7422 11.7671 2.7422 11.3872 2.97652 11.1529L5.0206 9.10884C5.25491 8.87453 5.63481 8.87453 5.86913 9.10884Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.5992 7.91113C12.9305 7.91113 13.1992 8.17976 13.1992 8.51113V9.53317C13.1992 10.2344 12.9206 10.907 12.4247 11.4028C11.9289 11.8987 11.2563 12.1773 10.5551 12.1773H3.40078C3.06941 12.1773 2.80078 11.9086 2.80078 11.5773C2.80078 11.2459 3.06941 10.9773 3.40078 10.9773H10.5551C10.9381 10.9773 11.3054 10.8251 11.5762 10.5543C11.847 10.2835 11.9992 9.91617 11.9992 9.53317V8.51113C11.9992 8.17976 12.2678 7.91113 12.5992 7.91113Z'
        fill={color}
      />
    </svg>
  );
};

export default IconMove;
